import Link from "next/link";

import styles from "./BlogCategoryButton.module.css";

function BlogCategoryButton({ slug, categoryTitle, onClick, review }) {
  if (review)
    return (
      <div className="col-md-2">
        <Link href="/reviews/" scroll={false}>
          <a>
            <button type="button" className={styles.button} onClick={onClick}>
              Album Reviews
            </button>
          </a>
        </Link>
      </div>
    );

  return (
    <div className="col-md-2">
      <Link href={`/blog/${slug}/`} scroll={false}>
        <a>
          <button type="button" className={styles.button} onClick={onClick}>
            {categoryTitle}
          </button>
        </a>
      </Link>
    </div>
  );
}

export default BlogCategoryButton;
